import { useCallback, useRef, useState } from "react";

/** Inline rename: click to edit, Enter or blur saves a changed non-empty title, Escape cancels. */
export const useStoryHeaderTitleInternalState = (
  storyTitle: string,
  onTitleSave?: (title: string) => void,
) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const settled = useRef(false);

  const start = useCallback(() => {
    if (!onTitleSave) return;
    settled.current = false;
    setDraft(storyTitle);
    setIsEditing(true);
  }, [onTitleSave, storyTitle]);

  const commit = useCallback(() => {
    if (settled.current) return;
    settled.current = true;
    setIsEditing(false);
    const next = draft.trim();
    if (next && next !== storyTitle) onTitleSave?.(next);
  }, [draft, storyTitle, onTitleSave]);

  const cancel = useCallback(() => {
    settled.current = true;
    setIsEditing(false);
  }, []);

  return { isEditing, draft, setDraft, start, commit, cancel };
};
